import { render, staticRenderFns } from "./footer-custom.vue?vue&type=template&id=4150db34&scoped=true&"
import script from "./footer-custom.vue?vue&type=script&lang=js&"
export * from "./footer-custom.vue?vue&type=script&lang=js&"
import style0 from "./footer-custom.vue?vue&type=style&index=0&id=4150db34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150db34",
  null
  
)

export default component.exports